<template>
    <v-container class="fill-height" style="display: block;" fluid>
        
        <div id="ag-grid-container">
            <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                :gridOptions="gridOptions"
                @row-double-clicked="(params) => editItem(params.data)"
                :groupHeaders="true"
                :rowHeight="40">
            </ag-grid-vue>
        </div>

        <v-btn color="#c42111" class="mt-3 mr-3" @click="addNewItem" :disabled="lockSave" v-if="showGrid">New</v-btn>
        <v-btn color="#c42111" class="mt-3 mr-3" @click="saveClick" :disabled="lockSave || !$store.state.isDirty" v-if="showGrid">Save</v-btn>

        <v-dialog v-model="showEditItem" max-width="80%" width="800px" :persistent="true" v-if="showEditItem">
            <snmp-edit :pmGroupItems="pmGroupItems" :snmpItemClone="selectedItemClone" @cancel="cancelClicked" @ok="okClicked" />
        </v-dialog>

    </v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import SnmpEdit from "@/components/Devices/SnmpEdit";
export default {
    name: 'Snmp',
    props: [],
    components: {
        'ag-grid-vue': AgGridVue,
        SnmpEdit
    },
    data: () => ({
        showGrid: false,
        gridOptions: {},
        pmGroupItems: [],
        pmCollectList: [],
        lockSave: false,
        showEditItem: false,
        selectedItemClone: null
    }),

    computed: {
    },

    methods: {
        getSnmpCollectConfig: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "snmp/collect");
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.pmCollectList = result.pm_collect_snmp_list;
                this.pmGroupItems = result.pm_groups;
                this.buildAgGrid();
                TELSA.loading(false);
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.pmCollectList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'snmpList');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle ping-target-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle ping-target-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.ping-target-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.ping-target-action')[1];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            if(!self.lockSave) {
                                this.editItem(params.data);
                            }
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave) {
                                this.deleteItemClick(params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'Host', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'key'
                },
                { 
                    headerName: 'Version', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'version'
                },
                { 
                    headerName: 'Community', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'community'
                },
                { 
                    headerName: 'Frequency', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(params.data.frequency == 86400) {
                            return ['24 Hours'];
                        }
                        let hms = new Date(params.data.frequency * 1000).toISOString().substr(11, 8);
                        let h = parseInt(hms.split(':')[0]);
                        let m = parseInt(hms.split(':')[1]);
                        let s = parseInt(hms.split(':')[2]);
                        let strArr = [];
                        if(h > 0 )strArr.push(`${h} Hours`);
                        if(m > 0 )strArr.push(`${m} Minutes`);
                        if(s > 0 )strArr.push(`${s} Seconds`);
                        return strArr;
                    }
                },
                { 
                    headerName: 'PM Groups', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        let values = [];
                        for(let val of params.data.pm_groups) {
                            for(let pmg of self.pmGroupItems) {
                                if(val == pmg.value) {
                                    values.push(pmg.text);
                                    break;
                                }
                            }
                        }
                        return values.sort();
                    }
                },
            ];
            return columnDefs;
        },

        cancelClicked: function() {
            this.selectedItemClone = null;
            this.showEditItem = false;
        },

        okClicked: function() {
            if(this.selectedItemClone.unique_key == 'new') {
                this.selectedItemClone.unique_key = `${this.selectedItemClone.section}_${this.selectedItemClone.key}`;
                this.pmCollectList.push(this.selectedItemClone);
            }
            else {
                let idx = this.pmCollectList.findIndex(x => x.unique_key == this.selectedItemClone.unique_key)
                this.pmCollectList[idx] = this.selectedItemClone;
            }

            this.showEditItem = false;
            this.gridOptions.api.setRowData(this.pmCollectList);
            this.$store.commit('setIsDirty', true);
            this.selectedItemClone = null;
        },

        addNewItem: function() {
            this.selectedItemClone = {
                key: '',
                version: '',
                community: '',
                frequency: null,
                pm_groups: [],
                section: 'pm_collect_snmp',
                comment: '',
                unique_key: 'new'
            };
            this.showEditItem = true;
        },

        editItem: function(item) {
            this.selectedItemClone = JSON.parse(JSON.stringify(item));
            this.showEditItem = true;
        },

        deleteItemClick: function(item) {
            this.pmCollectList.splice(this.pmCollectList.indexOf(item), 1);
            this.gridOptions.api.setRowData(this.pmCollectList);
        },

        saveClick: function() {
            if(this.$store.state.isDirty) {
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to commit your changes?',
                    type: '',
                    confirmAction: () => { this.save(); }
                });
            }
        },

        save: function() {
            let route = (TELSA.apiHost + "snmp/collect");
            TELSA.loading(true);
            for(let p of this.pmCollectList) {
                p.value = JSON.stringify({version: p.version, community: p.community, frequency: p.frequency, pm_groups: p.pm_groups});
                p.comment = p.comment || "";
            }
            return this.$http.post(route, {args: {lock: this.$store.state.lock, pmCollectList: this.pmCollectList}}).then(response => {
                let result = response.body;
                this.$store.commit('setIsDirty', false);
                TELSA.loading(false);
            });
        },

    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/device-passwords');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getSnmpCollectConfig()}
            });
            this.lockSave = true;
            return;
        }

        let lockName = `edit_tsini`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getSnmpCollectConfig().then(r => {
                if(lockOwner) {
                    // Disable save and let user know page is locked!
                    this.lockSave = true;
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The SNMP page is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }
            });
        });
    },

    watch: {
        pmCollectList(newVal, oldVal) {
            if(!this.gridOptions.api) {
                return;
            }
            if(!this.lockSave) {
                this.$store.commit('setIsDirty', true);
            }
            this.gridOptions.api.setRowData(this.pmCollectList);
        },
    },

  
};
</script>

<style scoped>

    #ag-grid-container {
        height: calc(100vh - 126px);
    }

</style>
